import { PropOptions } from "vue";
import { TRoles } from "@timesheets/constants-common";
/**
 * If set, then we are currently impersonating the given role
 */
export function getImpersonatingRoleProp() {
  return {
    type: [Object],
    required: false,
  } as PropOptions<TRoles["RecruitmentAgencyAdministrationRole"]>;
}
